module.exports = __webpack_public_path__ + "static/images/up-bg.2211d8a.png";